import {removeAccents} from '@s-ui/js/lib/string'

import FormattedNewsTagValueObject from './FormattedNewsTagValueObject.js'
import HomeNewsValueObject from './HomeNewsValueObject.js'
import {LatestPlatesValueObject} from './LatestPlatesValueObject.js'
import {ModelDetailNewsValueObject} from './ModelDetailNewsValueObject.js'
import {NewsDetailRequestValueObject} from './NewsDetailRequestValueObject.js'
import NewsPaginationValueObject from './NewsPaginationValueObject.js'
import NewsSearchUrlValueObject from './NewsSearchUrlValueObject.js'
import NewsSuggestionsValueObject from './NewsSuggestionsValueObject.js'
import {NewsTagsListValueObject} from './NewsTagsListValueObject.js'
import {NewsTagValueObject} from './NewsTagValueObject.js'
import NewsValueObject from './NewsValueObject.js'

export default class NewsValueObjectsFactory {
  static newsDetailRequestValueObject = ({articleId, locale, slug}) =>
    new NewsDetailRequestValueObject({
      articleId,
      locale,
      slug
    })

  static modelDetailNewsValueObject = ({news, videos, videopruebas}) =>
    new ModelDetailNewsValueObject({
      news,
      videos,
      videopruebas
    })

  static newsValueObject = ({pageItems, page, items, count}) =>
    new NewsValueObject({
      pageItems,
      page,
      items,
      count
    })

  // TO-DO: A factory function that return another function!
  static newsPaginationValueObject =
    () =>
    ({previous, next}) =>
      new NewsPaginationValueObject({previous, next})

  static homeNewsValueObject = items => new HomeNewsValueObject({items})

  static newsSuggestionsValueObject = ({config, literal, model}) =>
    new NewsSuggestionsValueObject({
      config,
      literal,
      model
    })

  static formattedNewsTagValueObject =
    ({config}) =>
    ({tag}) =>
      new FormattedNewsTagValueObject({config, tag})

  static newsSearchUrlValueObject =
    ({config}) =>
    ({tag, category, searchTerm, section, page}) =>
      new NewsSearchUrlValueObject({
        config,
        tag,
        category,
        searchTerm,
        page,
        section,
        removeAccents
      })

  static newsTagValueObject = ({tag}) => new NewsTagValueObject({tag})

  static newsTagsListValueObject = ({items}) => new NewsTagsListValueObject({items})

  static latestPlatesValueObject = ({config, lastPlate, plates, date, stats}) =>
    LatestPlatesValueObject.create({config, lastPlate, plates, date, stats})
}
